import { usePlatformStore } from '@/store-pinia/platform'
import * as domainSettingService from '@/service/domainSetting'
import { BranchStatus } from '@/view-models/branch'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const config = useRuntimeConfig()
  const nuxtApp = useNuxtApp()
  const $pinia = nuxtApp.$pinia
  const route = to
  const { params } = route

  const platformStore = usePlatformStore($pinia)

  if (!platformStore.isFunNowDomain || !platformStore.isFunBookV2Path) {
    return
  }

  let domainInfo = {}
  try {
    const branchId = params.branch_id
    domainInfo = await domainSettingService.verifyDomainCustomization(nuxtApp.$axios, { branchId }).then(res => res.data)
  } catch (err) {
    console.log('verifyDomainCustomization error is: ', err.message)
    throw nuxtApp.runWithContext(() => showError({ statusCode: 404, message: 'Post not found', fatal: true }))
  }

  if (domainInfo.domain) {
    console.log('will redirect to custom domain')
    const isLocalEnv = config.public.CONFIG_ENV === 'local'
    return nuxtApp.runWithContext(() =>
      navigateTo(`${domainInfo.domain}${isLocalEnv ? ':8082' : ''}/${nuxtApp.$i18n.locale.value}/funbook/${domainInfo.branch_id}/branch`, {
        external: true,
      })
    )
  }

  if (domainInfo.funbook_ver !== 2 || domainInfo.branch_status !== BranchStatus.Enabled) {
    console.log('not v2 in FN domain')
    throw nuxtApp.runWithContext(() => showError({ statusCode: 404, message: 'Post not found', fatal: true }))
  }
})
